import { render, staticRenderFns } from "./form-invoice-type.vue?vue&type=template&id=6c0e014c&scoped=true&"
import script from "./form-invoice-type.vue?vue&type=script&lang=js&"
export * from "./form-invoice-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0e014c",
  null
  
)

export default component.exports